module.exports = __webpack_public_path__ + "img/user_management_nav.30dd7e04.svg";